<div
  class="contact-us-container"
>
  <div
    fxLayout="column"
    fxLayout.gt-xs="row wrap"
    fxLayoutAlign="center center"
    fxLayoutAlign.gt-xs="space-between center"
    class="container"
  >
    <div
      fxLayout="column"
      fxLayoutAlign="center center"
      fxLayoutAlign.gt-xs="center start"
    >
      <h3
        class="title"
      >
        {{ 'shared.contact_us.title' | translate }}
      </h3>
      <p
        class="content"
        [innerHTML]="'shared.contact_us.' + component | translate"
      >
      </p>
    </div>
    <a
      mat-raised-button
      color="transparent"
      [routerLink]="[basePath, 'contacteaza-ne']"
    >
      {{ 'shared.contact_us.button' | translate }}
    </a>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/components/contact-us/contact-us.component.html